export enum MlbSportId {
  MLB = 1,
  MiLB = 11,
  AA = 12,
  HighA = 13,
  A = 14,
  Rookie = 16,
}
